import { IWord } from '../models/IWord';
import { Errors, HttpMetod, IAggreagtedWords } from './constants';
import { path } from './url';

const { GET, CONTENT_TYPE } = HttpMetod;

///Получить слова определенной группы, определенной страницы c возможностью фильтрации
export const getAggregatedWordsList = async (options: {
  userId: string;
  group?: string;
  page?: string;
  wordsPerPage?: string;
  filter?: string;
}): Promise<IWord[]> => {
  const filterGroup: string = options.group ? `group=${options.group}` : '';
  const filterPage: string = options.page ? `page=${options.page}` : '';
  const filterWordsPerPage: string = options.wordsPerPage
    ? `wordsPerPage=${options.wordsPerPage}`
    : '';
  const filterFilter: string = options.filter ? `filter=${options.filter}` : '';
  const sumFilter: string = [filterGroup, filterPage, filterWordsPerPage, filterFilter].join('&');
  const finalFilter = `?${sumFilter.slice(1)}`;

  const rawResponse = await fetch(
    `${path.users}/${options.userId}/aggregatedWords?${finalFilter}`,
    {
      method: GET,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('userToken')}`,
        Accept: CONTENT_TYPE,
      },
    },
  );

  if (rawResponse.status === Errors.INVALID_TOKEN) {
    throw new Error('Access token is missing or invalid');
  }
  if (!rawResponse.ok) {
    throw new Error('Something wrong!');
  }

  const content = await rawResponse.json();

  return content[0].paginatedResults;
};
